// app/javascript/projects/components/TeamModal.jsx

import React, { useState } from 'react';
import { Button } from 'ui'
import {Modal} from 'ui'
import TeamModalMain from './TeamModalMain'
import TeamModalAdd from './TeamModalAdd'
import TeamModalSubscription from './TeamModalSubscription'
import TeamModalDetail from './TeamModalDetail'
import TeamModalRemove from './TeamModalRemove'
import AccountPageConstants from 'constants/AccountPageConstants'
import { useTeamModal } from '../../hooks/subscriptions/useTeamModal';

function TeamModal() {
  const [pageData, setPageData] = useState({});
  const { page, showTeamModal, closeModal, navigateToPage, PAGES } = useTeamModal();

  const onHide = () => {
    closeModal();
    setPageData({});
  };

  const handleNavigate = (newPage, data = {}) => {
    setPageData(prev => ({ ...prev, ...data }));
    navigateToPage(newPage);
  };

  const handleSetPageData = (data) => {
    setPageData(prev => ({ ...prev, ...data }));
  };

  const backButtonPressed = () => {
    let newPage = PAGES.MAIN_PAGE;
    switch (page) {
      case PAGES.MAIN_PAGE:
      case PAGES.ADD_MEMBERS:
      case PAGES.MEMBER_DETAIL:
        newPage = PAGES.MAIN_PAGE;
        break;
      case PAGES.PAYMENT:
        newPage = PAGES.ADD_MEMBERS;
        break;
      case PAGES.MEMBER_DELETE:
        newPage = PAGES.MEMBER_DETAIL;
        break;
    }
    navigateToPage(newPage);
  };

  let pageContent = <div></div>;

  switch (page) {
    case AccountPageConstants.MAIN_PAGE:
      pageContent = <TeamModalMain 
        navigateToPage={handleNavigate}
        PAGES={PAGES}
      />
      break;
    case AccountPageConstants.ADD_MEMBERS:
      pageContent = <TeamModalAdd
        navigateToPage={handleNavigate}
        PAGES={PAGES}
        setPageData={handleSetPageData}
      />
      break;
    case AccountPageConstants.PAYMENT:
      pageContent = <TeamModalSubscription
        pageData={pageData}
        navigateToPage={handleNavigate}
        PAGES={PAGES}
      />
      break;
    case AccountPageConstants.MEMBER_DETAIL:
      pageContent = <TeamModalDetail
        navigateToPage={handleNavigate}
        PAGES={PAGES}
        pageData={pageData}
      />
      break;
    case AccountPageConstants.MEMBER_DELETE:
      pageContent = <TeamModalRemove
        pageData={pageData}
        navigateToPage={handleNavigate}
        PAGES={PAGES}
      />
      break;
  }

  const mainPage = page == AccountPageConstants.MAIN_PAGE;

  return (
    <div>
      <Modal show={showTeamModal} onHide={onHide}>
        <Modal.Body>
          <div style={{minHeight:"33px"}}>
            {!mainPage &&
              <Button variant="link" onClick={backButtonPressed}>Back</Button>
            }
          </div>
          <div style={{margin:"0px 33px"}}>
            {pageContent}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TeamModal;